/**
 * 阿里云对象操作
 */
 import store from '../store/index';
 import { Message, Loading } from 'element-ui';
//  import AWS from "aws-sdk";
import OSS from 'ali-oss';
 import {isAssetTypeAnImage} from './func';
 import compressor from '@/utils/compressorFun';

 let loading = null;

// 判断文件是否在规定大小内
async function fileSizeHandle(file, quality = 0.8){
    // console.log(quality);
    let res;
    let fileSize = Number(file.size);
    let fileSizeKB = Math.round(fileSize / 1024 * 100) / 100;   //获取图片的大小 kb
    // if(fileSizeKB > 40 ){
    //     let resFile = await compressor(file, quality, 'file');
    //     let newFileSizeKB = Math.round(Number(resFile.size) / 1024 * 100) / 100;   //获取图片的大小 kb
    //     // console.log(fileSizeKB);
    //     if(newFileSizeKB >= 40){
    //         res = await fileSizeHandle(file, newFileSizeKB, Math.round((quality - 0.1) * 10) / 10);
    //     }else{
    //         res = resFile;
    //     }
    // }
    if(fileSizeKB > 500){
        res = await compressor(file, quality, 'file')
    }else{
        res = file;
    }
    return res;
}

// 判断是否为文件对象
function isFile(obj) {
  return typeof obj === 'object' && obj !== null &&
    Object.prototype.toString.call(obj) === '[object File]';
}

 // 处理返回数据
function resDataHandle(v, isName){
    let urls = '';
    if(isName){
        urls = JSON.stringify(v);
    }else{
        urls = v.join(',');
    }
    return urls;
}

/**
 * 上传单个文件
 * @param {*} fileObject :上传文件对象{name:'',url:'',raw:file}
 * @param {*} callBack :回调
 * @param {*} filePath :上传到的天翼云文件夹路径
 * @param {*} type :如果识别不了type 手动加一个
 * @param {*} isName : 是否需要返回name，true: 返回对象
 * @param {*} quality : 压缩
 */
export async function putObject(fileObject, callBack, callbackPercent, filePath = "file", type = '', isName = false, quality = 0.1, isLoading = true) {
    // console.log(fileObject);

    // fileObject为空返回''
    if (!fileObject) {
        callBack('');
        return false;
    }

    // 已经存在该文件则不上传,直接返回
    if (!fileObject.raw && !fileObject.file && fileObject.url) {
        if(isName){
            callBack({
                url: fileObject.url,
                name: fileObject.name,
            });
        }else{
            callBack(fileObject.url);
        }
        // callBack(fileObject.url);
        return false;
    }

    // console.log(fileObject);
    if(isLoading){
        loading = Loading.service({
            fullscreen: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        }); 
    }
    // 上传
    if (!store.state.common.OSS_REGION) {
        //初始化天翼云签名
        await store.dispatch('common/getS3ClientAction');
    }
    let date = new Date();
    let file = fileObject.raw || fileObject.file || fileObject;
    const arr = file.name.split('.');
    const str = arr[arr.length - 1];
    // 判断图片
    if(isAssetTypeAnImage(str)){
        file = await fileSizeHandle(file, quality);
    }
    let num = Math.ceil(Math.random() * 1000);  //随机数
    let fileKey = `${date.getTime()}${num}`; //文件的唯一标识
    let fileName = `${filePath}/${date.getFullYear()}-${date.getMonth() + 1}/${fileKey}.${str}`;
    
    const fileSize = file.size;
    const partSize = 1024 * 1024 * 5;  //分片大小 5M

    const client = new OSS({
        region: store.state.common.OSS_REGION,
        accessKeyId: store.state.common.ACCESS_KEY_ID,
        accessKeySecret: store.state.common.ACCESS_KEY_SECRET,
        bucket: store.state.common.OSS_BUCKET
    });

    try{
        let res = null;
        if(fileSize > partSize){
            // console.log('分片');
            // console.log(file);
            res = await client.multipartUpload(fileName, file, {
                // parallel: 4,
                partSize,
                progress: (p) => {
                    // console.log(p);
                    let num = Math.floor(p * 100);
                    if (typeof callbackPercent == 'function') {
                        callbackPercent(num);
                    }
                }
            });
        }else{
            res = await client.put(fileName, file, {
                // parallel: 4,
                // partSize: 1024 * 1024 * 1,
                // progress: (p) => {
                //     console.log(p);
                //     callbackPercent(p);
                // }
            });
        }
        if(res){
            loading.close();
        
            const domain = 'https://www.cqjtjxjy.com/';
            let url = domain + res.name;
            // let url = res.url;
            // console.log(res);
            if(isName){
                let resData = {
                    url: url,
                    name: file.name,
                };
                callBack(JSON.stringify(resData));
            }else{
                callBack(url);
            }
        }
    }catch(err){
        loading.close();
        Promise.reject(err);
        Message.error('上传失败');
    }
}

/**
 * 多文件上传
 * @param {*} fileObject :上传文件对象Array:[{name:'',url:''}]
 * @param {*} callBack :回调
 * @param {*} filePath :上传到的天翼云文件夹路径
 * @param {*} type :如果识别不了type 手动加一个
 * @param {*} isName : 是否需要返回name，true: 返回对象
 * @param {*} quality : 压缩
 */
export function uploadFiles(fileObjects, callBack, callbackPercent, filePath = "file", type = '', isName = false, quality = 0.1) {
    // console.log(fileObjects);
    if (fileObjects && fileObjects.length == 0) {
        callBack([]);
        return false;
    }

    loading = Loading.service({
        fullscreen: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
    }); 

    // 上传
    let callBackList = [];
    let uploadNum = 0;
    for(let i in fileObjects){
        let fileObject = fileObjects[i];
        let file = fileObject.raw || fileObject.file || fileObject;
        if(!isFile(file)){
            continue;
        }
        // 已经存在该文件则不上传,直接返回
        if (!fileObject.raw && !fileObject.file && fileObject.url) {
            if(isName){
                callBackList.push({
                    url: fileObject.url,
                    name: fileObject.name,
                });
            }else{
                callBackList.push(fileObject.url);
            }
            uploadNum += 1;
            if(uploadNum == fileObjects.length){
                if (typeof callBack == 'function') {
                    // let urls = callBackList.join(',');
                    let urls = resDataHandle(callBackList, isName);
                    loading.close();
                    callBack(urls);
                }
            }
            continue;
        }

        // let file = fileObject.raw || fileObject.file || fileObject;
        // let arr = file.name.split('.');
        // let str = arr[arr.length - 1];
        // let date = new Date();
        // let num = Math.ceil(Math.random() * 1000);  //随机数
        // let fileKey = `${date.getTime()}${num}`; //文件的唯一标识
        // let fileName = `${filePath}/${date.getFullYear()}-${date.getMonth() + 1}/${fileKey}.${str}`;

        // 总的上传进度
        let totalProcessData = {};

        putObject(fileObject, (res) => {
            if(isName){
                let resData = JSON.parse(res);
                callBackList.push({
                    url: resData.url,
                    name: resData.name,
                });
            }else{
                callBackList.push(res);
            }
            uploadNum += 1;
            if(uploadNum == fileObjects.length){
                if (typeof callBack == 'function') {
                    // let urls = callBackList.join(',');
                    let urls = resDataHandle(callBackList, isName);
                    loading.close();
                    callBack(urls);
                }
            }
        }, (progressEvent) => {
            // 计算总的进度 思路：单个文件的进度相加 / 总的个数
            let currentProcess = progressEvent;  //当前上传的进度
            totalProcessData['process' + i] =  currentProcess;
            let totalProcess = 0;
            for(let key in totalProcessData){
                totalProcess += totalProcessData[key];
            }
            let uploadProcess = Math.floor(totalProcess / fileObjects.length);
            // console.log(uploadProcess);
            if (typeof callbackPercent == 'function') {
                callbackPercent(uploadProcess);
            }
        }, filePath, type, isName, quality, false);
    }
}

 export async function putObjectBlob(fileObject, callBack, callbackPercent, filePath = "gamma/images", type = '', isName = false, quality = 0.1, isLoading = true) {
    if(fileObject instanceof Blob){
        let data = new window.File([fileObject], 'faceRecognition.png', {type: 'image/jpeg'});
        putObject(data, callBack, callbackPercent, filePath, type, isName, quality, isLoading);
        // let resultData = new FileReader();
        // resultData.readAsText(fileObject, 'utf-8');
        // resultData.onload =  (e) => {
        //     console.log(resultData.result);
        //     let data = JSON.parse(resultData.result);
        //     putObject(data, callBack, callbackPercent, filePath, type);
        // }
    }else{
        putObject(fileObject, callBack, callbackPercent, filePath, type, isName, quality, isLoading);
    }
 }

 /**
  * 删除单个文件
  * @param {*} fileObject :文件对象
  * @param {*} callBack :回调
  * @param {*} filePath :文件路径
  */
 export function deleteObject(fileObject, callBack, filePath = "/gamma") {
     if (!fileObject) {
         return false;
     }

     if (fileObject.raw) {
         return false;
     }

     let inx = fileObject.url.indexOf(filePath);
     let name = fileObject.url.substr(inx);
     store.state.common.cos.deleteObject({
             ...store.state.common.cosDatas,
             Key: name /* 必须 */
         },
         function(err, data) {
             if (typeof callBack == 'function') {
                 callBack(err, data);
             }
         }
     );
 }

 /**
  * 下载文件
  * @param {*} key :文件名
  * @param {*} callBack :回调
  */
 // export function getObject(key, callBack) {
 //     store.state.common.cos.getObject(
 //         {
 //             ...store.state.common.cosDatas,
 //             Key: key /* 必须 */,
 //         },
 //         function (err, data) {
 //             if (typeof callBack == 'function') {
 //                 callBack(err, data);
 //             }
 //         }
 //     );
 // }
